import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCompanyApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getCompany = createAsyncThunk('getCompany', async (payload) => {
  return await getCompanyApi(payload);
});

const getCompanySlice = createSlice({
  name: 'getCompany', // Unique Name
  initialState,
  reducers: {
    getCompanyReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompany.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getCompany.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getCompany.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getCompanyReset } = getCompanySlice.actions;

export default getCompanySlice.reducer;
